import React, { Component } from 'react';
import { connect } from 'react-redux';

import { saveQuestionnaire } from '../../../../_actions/questionnaire.actions';
import { alertActions } from '../../../../_actions/alert.actions'
import Step from './Step';

import './style.css';

class ProgressBar extends Component {

  constructor(props) {
    super(props);

    this.state = { step: props.step }

    this.handleSave = this.handleSave.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.step !== this.props.step) {
      this.setState({
        step: this.props.step
      });
    }
  }

  handleSave() {
    this.props.saveQuestionnaire();
  }

  render() {
    const { enableHPI, step, isSaving } = this.props;

    let questionnaireProps,
      noteProps,
      documentProps;

    switch (this.state.step) {
      case 'QUESTION_BUILDER':
        questionnaireProps = { active: true };
        break;
      case 'HPI_BUILDER':
        questionnaireProps = { completed: true };
        noteProps = { active: true };
        break;
      case 'DOCUMENT_BUILDER':
        questionnaireProps = { completed: true };
        noteProps = { completed: true };
        documentProps = { active: true };
        break;
      default:
        break;
    }

    return (
      <div className="progressbar">
        <div className="progressbar-buttons">
          <a onClick={(e) => {
            e.preventDefault();

            this.props.back();
          }} href="#!" className={`btn btn-outline-primary`}>Back</a>
        </div>

        <ul className="stepper">
          <Step label="Form Builder" type="QUESTION_BUILDER" {...questionnaireProps} click={this.props.click} />
          {enableHPI &&
            <Step label="HPI Builder" type="HPI_BUILDER" click={this.props.click}  {...noteProps} />
          }
          <Step label="Document Builder" type="DOCUMENT_BUILDER" click={this.props.click} {...documentProps} />
        </ul>

        {step !== 'DOCUMENT_BUILDER' &&
          <div className="progressbar-buttons">
            <a onClick={(e) => {
              e.preventDefault();
              this.props.next();
            }} href="#!" className="btn btn-primary">
              Next
            </a>
          </div>
        }

        {step === 'DOCUMENT_BUILDER' &&
          <div className="progressbar-buttons">
            <button
              onClick={(e) => { e.preventDefault(); this.handleSave(); }}
              disabled={isSaving}
              type="button"
              className="btn btn-primary">
              {isSaving ? 'Saving' : 'Save'}
            </button>
          </div>
        }
      </div>

    );
  }
}

const mapStateToProps = (state) => {
  const HPIquestions = state.questionnaire.current.item.filter((item) => {
    const isNote = item.extension.find((extension) => {
      return extension.url === 'https://axshealthapp.com/fhir/StructureDefinition/questionnaire-item-note' &&
        extension.valueBoolean;
    })

    return isNote;
  });

  return {
    enableHPI: HPIquestions.length > 0,
    isSaving: state.questionnaire.isSaving
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    saveQuestionnaire: () => { dispatch(saveQuestionnaire()) },
    alertError: (message) => { dispatch(alertActions.error(message)) }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProgressBar);